module.exports = __webpack_public_path__ + "img/light-mud-decal-04.d405aac8.png";